import _styled2 from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { attachPropertiesToComponent } from '@code/utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Skeleton = /*#__PURE__*/_styled2("div", process.env.NODE_ENV === "production" ? {
  target: "e10kjukg0"
} : {
  target: "e10kjukg0",
  label: "Skeleton"
})(process.env.NODE_ENV === "production" ? {
  name: "1tftetn",
  styles: "height:100%;width:100%;border-radius:0.25rem; display:inline-block;vertical-align:top;background:linear-gradient(\n    90deg,\n    rgba(235, 235, 240, 0.12) 25%,\n    rgba(235, 235, 240, 0.18) 37%,\n    rgba(235, 235, 240, 0.12) 63%\n  );background-size:400% 100%;animation-name:code_ui-skeleton-loading;animation-duration:1.4s;animation-timing-function:ease;animation-iteration-count:infinite;@keyframes code_ui-skeleton-loading{0%{background-position:100% 50%;}100%{background-position:0 50%;}}"
} : {
  name: "1tftetn",
  styles: "height:100%;width:100%;border-radius:0.25rem; display:inline-block;vertical-align:top;background:linear-gradient(\n    90deg,\n    rgba(235, 235, 240, 0.12) 25%,\n    rgba(235, 235, 240, 0.18) 37%,\n    rgba(235, 235, 240, 0.12) 63%\n  );background-size:400% 100%;animation-name:code_ui-skeleton-loading;animation-duration:1.4s;animation-timing-function:ease;animation-iteration-count:infinite;@keyframes code_ui-skeleton-loading{0%{background-position:100% 50%;}100%{background-position:0 50%;}}/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNrZWxldG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHMkIiLCJmaWxlIjoiU2tlbGV0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYXR0YWNoUHJvcGVydGllc1RvQ29tcG9uZW50IH0gZnJvbSAnQGNvZGUvdXRpbHMnO1xuaW1wb3J0IHR3LCB7IHN0eWxlZCB9IGZyb20gJ3R3aW4ubWFjcm8nO1xuXG5jb25zdCBTa2VsZXRvbiA9IHN0eWxlZC5kaXZgXG4gICR7dHdgdy1mdWxsIGgtZnVsbCByb3VuZGVkLTFgfVxuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIHZlcnRpY2FsLWFsaWduOiB0b3A7XG4gIGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudChcbiAgICA5MGRlZyxcbiAgICByZ2JhKDIzNSwgMjM1LCAyNDAsIDAuMTIpIDI1JSxcbiAgICByZ2JhKDIzNSwgMjM1LCAyNDAsIDAuMTgpIDM3JSxcbiAgICByZ2JhKDIzNSwgMjM1LCAyNDAsIDAuMTIpIDYzJVxuICApO1xuICBiYWNrZ3JvdW5kLXNpemU6IDQwMCUgMTAwJTtcbiAgYW5pbWF0aW9uLW5hbWU6IGNvZGVfdWktc2tlbGV0b24tbG9hZGluZztcbiAgYW5pbWF0aW9uLWR1cmF0aW9uOiAxLjRzO1xuICBhbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOiBlYXNlO1xuICBhbmltYXRpb24taXRlcmF0aW9uLWNvdW50OiBpbmZpbml0ZTtcblxuICBAa2V5ZnJhbWVzIGNvZGVfdWktc2tlbGV0b24tbG9hZGluZyB7XG4gICAgMCUge1xuICAgICAgYmFja2dyb3VuZC1wb3NpdGlvbjogMTAwJSA1MCU7XG4gICAgfVxuICAgIDEwMCUge1xuICAgICAgYmFja2dyb3VuZC1wb3NpdGlvbjogMCA1MCU7XG4gICAgfVxuICB9XG5gO1xuXG5jb25zdCBBcnRpY2xlID0gKCkgPT4gKFxuICA8ZGl2IHR3PVwidy1mdWxsIHAtNiBmbGV4IGZsZXgtY29sIGl0ZW1zLXN0YXJ0XCI+XG4gICAgPFNrZWxldG9uIHR3PVwidy0xLzQgaC01IG1iLTRcIiAvPlxuICAgIDxTa2VsZXRvbiB0dz1cInctMy80IGgtNyBtYi00XCIgLz5cbiAgICA8U2tlbGV0b24gdHc9XCJ3LWZ1bGwgaC03IG1iLTRcIiAvPlxuICA8L2Rpdj5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGF0dGFjaFByb3BlcnRpZXNUb0NvbXBvbmVudChTa2VsZXRvbiwgeyBBcnRpY2xlIH0pO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _ref = process.env.NODE_ENV === "production" ? {
  name: "cvu4kv",
  styles: "display:flex;width:100%;flex-direction:column;align-items:flex-start;padding:1.5rem"
} : {
  name: "1oap9xv-Article",
  styles: "display:flex;width:100%;flex-direction:column;align-items:flex-start;padding:1.5rem;label:Article;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "xofbad",
  styles: "margin-bottom:1rem;height:1.25rem;width:25%"
} : {
  name: "eko0cv-Article",
  styles: "margin-bottom:1rem;height:1.25rem;width:25%;label:Article;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref3 = process.env.NODE_ENV === "production" ? {
  name: "15zw4b9",
  styles: "margin-bottom:1rem;height:1.75rem;width:75%"
} : {
  name: "1tizcic-Article",
  styles: "margin-bottom:1rem;height:1.75rem;width:75%;label:Article;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref4 = process.env.NODE_ENV === "production" ? {
  name: "19dzcby",
  styles: "margin-bottom:1rem;height:1.75rem;width:100%"
} : {
  name: "11byxvy-Article",
  styles: "margin-bottom:1rem;height:1.75rem;width:100%;label:Article;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var Article = function Article() {
  return ___EmotionJSX("div", {
    css: _ref
  }, ___EmotionJSX(Skeleton, {
    css: _ref2
  }), ___EmotionJSX(Skeleton, {
    css: _ref3
  }), ___EmotionJSX(Skeleton, {
    css: _ref4
  }));
};
export default attachPropertiesToComponent(Skeleton, {
  Article: Article
});